<script setup lang="ts">
import Author from '@/components/Sections/Author.vue'
import ToTop from '@/components/ToTop.vue'
</script>

<template>
    <RouterView />
    <Author />
    <ToTop />
</template>
